export var WGSLBindingType;
(function (WGSLBindingType) {
    WGSLBindingType["Mesh"] = "mesh";
    WGSLBindingType["Camera"] = "camera";
    WGSLBindingType["Texture"] = "texture";
    WGSLBindingType["Light"] = "light";
    WGSLBindingType["Interaction"] = "interaction";
})(WGSLBindingType || (WGSLBindingType = {}));
